export const ErrorsFromApi = {
  'account number must contain exactly 10 digits':
    'accountNumberValidation.account number must contain exactly 10 digits',
  'account number is outside the range':
    'accountNumberValidation.account number is outside the range',
  'invalid account number': 'accountNumberValidation.invalid account number',
  'account number failed the checksum test':
    'accountNumberValidation.account number failed the checksum test',
  'account number must not be null or empty':
    'accountNumberValidation.account number must not be null or empty',
  'violates rule blocked': 'accountNumberValidation.violates rule blocked',
  'violates rule': 'accountNumberValidation.violates rule',
};



// WEBPACK FOOTER //
// ./src/app/common/ui/account-number/accountNumber.errors.js